import React, { useContext, useState } from "react";

const SearchFilterContext = React.createContext();

export function useSearchFilters() {
    return useContext(SearchFilterContext);
}

export function SearchFilterProvider({ children }) {
    // Boat data state (cached across navigation)
    const [listings, setListings] = useState([]);
    const [boatLocations, setBoatLocations] = useState([]);
    const [filtersOptions, setFilterOptions] = useState([]);
    const [boatTypeOptions, setBoatTypeOptions] = useState([]);
    const [boatTypesFilters, setBoatTypesFilters] = useState([]);
    const [locationNames, setLocationNames] = useState({});
    const [boatFilters, setBoatFilters] = useState([]);
    const [ownerDetails, setOwnerDetails] = useState({});
    const [listingReviews, setListingReviews] = useState({});
    const [homeListingsReady, setHomeListingsReady] = useState(false);

    // Filter selection state (persisted across navigation)
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedBoatTypeOptions, setSelectedBoatTypeOptions] = useState([]);
    const [selectedFiltersOptions, setSelectedFiltersOptions] = useState([]);
    const [grabSelectedFilterOptions, setGrabSelectedFilterOptions] = useState([]);
    const [grabSearchLocation, setGrabSearchLocation] = useState("");
    const [searchAddress, setSearchAddress] = useState("");
    const [searchedLocation, setSearchedLocation] = useState(null);
    const [searchedLocationGeoData, setSearchedLocationGeoData] = useState(null);
    const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
    const [dateRange, setDateRange] = useState([null, null]);
    const [appliedAdultsCount, setAppliedAdultsCount] = useState(0);
    const [appliedChildrenCount, setAppliedChildrenCount] = useState(0);
    const [adultsCount, setAdultsCount] = useState(0);
    const [childrenCount, setChildrenCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const value = {
        // Boat data
        listings, setListings,
        boatLocations, setBoatLocations,
        filtersOptions, setFilterOptions,
        boatTypeOptions, setBoatTypeOptions,
        boatTypesFilters, setBoatTypesFilters,
        locationNames, setLocationNames,
        boatFilters, setBoatFilters,
        ownerDetails, setOwnerDetails,
        listingReviews, setListingReviews,
        homeListingsReady, setHomeListingsReady,
        // Filter selections
        selectedOptions, setSelectedOptions,
        selectedBoatTypeOptions, setSelectedBoatTypeOptions,
        selectedFiltersOptions, setSelectedFiltersOptions,
        grabSelectedFilterOptions, setGrabSelectedFilterOptions,
        grabSearchLocation, setGrabSearchLocation,
        searchAddress, setSearchAddress,
        searchedLocation, setSearchedLocation,
        searchedLocationGeoData, setSearchedLocationGeoData,
        selectedDateRange, setSelectedDateRange,
        dateRange, setDateRange,
        appliedAdultsCount, setAppliedAdultsCount,
        appliedChildrenCount, setAppliedChildrenCount,
        adultsCount, setAdultsCount,
        childrenCount, setChildrenCount,
        currentPage, setCurrentPage,
    };

    return (
        <SearchFilterContext.Provider value={value}>
            {children}
        </SearchFilterContext.Provider>
    );
}
